import React, { useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import Model from './Model';
import Input from './Input';
import ButtonCollection from './ButtonCollection';
import { DeleteButton } from './ConfirmButton';
import BuilderSubSectionTitle from '../backend/BuilderSubSectionTitle';
import { CreateButton } from './ActionButton';

import ActionLink from './ActionLink';
import TextArea from './TextArea';

import { v4 as uuidv4 } from 'uuid';
import { i18nIntl, isNotEmpty } from '../../lib/ep';
import { ListContainer, ListItemWrapper } from './ListItems';

function isJsonString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}

	return true;
};

const Item = (props) => {
	const change = (k, v) => {
		props.change(props.item.id, k, v);
	};

	const deleteField = () => {
		props.delete(props.item.id);
	};

	return (
		<ListItemWrapper>
			<div class="item_header">
				<div class="item_title_container is_inline">
					<Model model={props.item} change={change}>
						<Input
							name="k"
							//onKeyAction={{ key:'Backspace', action:deleteField }}
							autofocus={true}
							placeholder="Key"
							_class={{ first:true }}
						/>

						<Input
							name="v"
							placeholder="Value"
							_class={{ first:true }}
						/>
					</Model>
				</div>

				<ButtonCollection>
					<DeleteButton
						squared={true}
						_position="left"
						onClick={deleteField}
						aria-label="Delete"
					/>
				</ButtonCollection>
			</div>
		</ListItemWrapper>
	)
};

const KeyValueJSON = ({ json, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const full_name = `full_${props.name}`;

	const [ full, setFull ] = useState((isNotEmpty(props, 'full_json')) ? props.full_json : undefined);
	const [ items, setItems ] = useState(Object.keys(json).map((k) => ({
		id:uuidv4(),
		k,
		v:json[k],
	})));

	const formatJSON = (list) => {
		const js = {};
		list.map((item) => {
			js[item.k] = item.v;
		});

		return js;
	};

	const [ errors, setErrors ] = useState({});

	const change = (id, k, v) => {
		const new_array = items.map((item) => {
			if(item.id != id) return item;

			return {
				...item,
				[k]:v,
			};
		});

		setItems(new_array);
		props.change(props.name, formatJSON(new_array));
	};

	const deletePair = (id) => {
		const new_array = items.filter((item) => (item.id != id));
		setItems(new_array);
		props.change(props.name, formatJSON(new_array));
	};

	const addNew = () => {
		const new_array = [
			...items,
			{
				id:uuidv4(),
				k:'',
				v:''
			}
		];

		setItems(new_array);
		props.change(props.name, formatJSON(new_array));
	};

	const setFullMode = () => {
		setFull(JSON.stringify(json));
		props.change(full_name,JSON.stringify(json));
		props.change(props.name, "");
	};

	const setKeyPair = () => {
		setFull(undefined);
		props.change(full_name, "");
		props.change(props.name, formatJSON(items));
	};

	const changeFull = (k, v) => {
		setFull(v);

		const is_valid = isJsonString(v);
		if(!is_valid) {
			setErrors({ [`full_${props.name}`]:i18n("This JSON is not valid") });
		} else {
			setErrors({ });
			props.change(full_name, v);
		}
	};

	const section_title = props?.section_title ?? "Data structure";

	return (
		<div>
			{(full == undefined) && (
				<>
					<BuilderSubSectionTitle
						title={section_title}
						bordered={false}
						title_actions={<ButtonCollection>
							<CreateButton
								onClick={addNew}
							>Add key/value</CreateButton>
						</ButtonCollection>}
					/>

					<ListContainer>
						{items.length > 0 && items.map((item, index) => {
							return (
								<Item
									key={`item_${item.id}`}
									index={index}
									item={item}
									change={change}
									delete={deletePair}
								/>
							)
						})}

						{(items.length < 1) && (
							<ListItemWrapper>
								<div class="item_header">
									<div class="item_title_container gui_not_in_start_small">{i18n("No field")}</div>
								</div>
							</ListItemWrapper>
						)}
					</ListContainer>
				</>
			)}
			
			{(full) && (
				<Model
					change={changeFull}
					errors={errors}
				>
					<TextArea
						name={`full_${props.name}`}
						value={full}
					>Copy/paste the JSON structure</TextArea>
				</Model>
			)}

			{(full == undefined) ? (
				<ActionLink
					onClick={setFullMode}
				>Enter full JSON data</ActionLink>
			) : (
				<ActionLink
					onClick={setKeyPair}
				>Key pair value</ActionLink>
			)}
		</div>
	);
};

export default injectIntl(KeyValueJSON);